import React, { useState, useEffect } from "react";
import ProfileUpload from "../ProfileUploader";
import placeholderImg from "@src/assets/Signup/profile.png";
import { useSignupExpertStore } from "@src/store/signupExpertStore";
import { uploadExpertProfileImage } from "@src/api/expert/expertApi";
import { getDeviceType, WebAppBridge } from "@src/lib/WebAppBridge";

const SignupProfileUploadContainer: React.FC = () => {
    const { profileImageUrl, setProfileImageUrl } = useSignupExpertStore((state) => ({
        profileImageUrl: state.form.profileFileUrl,
        setProfileImageUrl: (url: string | null) =>
            state.setPartialState({
                form: { ...state.form, profileFileUrl: url ?? "" },
            }),
    }));

    useEffect(() => {
        if (getDeviceType() !== "android") return;

        WebAppBridge.onGetProfileImage = (imageUrl: string) => {
            setProfileImageUrl(imageUrl);
        };

        return () => {
            WebAppBridge.onGetProfileImage = undefined as any;
        };
    }, [setProfileImageUrl]);

    const [uploading, setUploading] = useState(false);

    const handleFileSelected = async (file: File) => {
        try {
            setUploading(true);
            const url = await uploadExpertProfileImage(file);
            setProfileImageUrl(url);
        } catch (e) {
            setProfileImageUrl(null);
        } finally {
            setUploading(false);
        }
    };

    return (
        <ProfileUpload
            imageUrl={profileImageUrl}
            placeholderSrc={placeholderImg}
            readOnly={false}
            isUploading={uploading}
            onFileSelected={handleFileSelected}
            addLabel="추가"
            changeLabel="이미지 변경"
        />
    );
};

export default SignupProfileUploadContainer;
